module.exports = __webpack_public_path__ + "img/no-itens.b3b80b00.svg";